import type { UploadFile } from 'antd';
import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

export const AddFamilyCommunicationRequestDtoSchema = z.object({
  title: z.string(),
  residentId: z.number(),
  date: z.date(),
  communicationFile: z.array(z.custom<UploadFile>()),
});

export const AddFamilyCommunicationResponseDtoSchema = z.object({
  date: z.coerce.date(),
  fileUrl: z.string(),
  id: z.number(),
  residentId: z.number(),
  title: z.string(),
  uploadedBy: z.object({
    id: z.number(),
    fullName: z.string(),
  }),
});

export type AddFamilyCommunicationRequestDto = z.infer<
  typeof AddFamilyCommunicationRequestDtoSchema
>;
export type AddFamilyCommunicationResponseDto = z.infer<
  typeof AddFamilyCommunicationResponseDtoSchema
>;

export const addFamilyCommunication = (
  params: AddFamilyCommunicationRequestDto,
  config?: AxiosRequestConfig
) => {
  const formData = new FormData();

  const d = params.date;

  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');

  formData.append('title', params.title);
  formData.append('residentId', String(params.residentId));
  formData.append('date', `${yyyy}-${mm}-${dd}`);

  params.communicationFile.forEach((file) => {
    if (file.originFileObj) {
      formData.append('communicationFile', file.originFileObj);
    }
  });

  return api
    .post('family-communication', formData, {
      ...config,
      headers: {
        'Content-Type': 'multipart/form-data',
        ...config?.headers,
      },
    })
    .then(responseContract(AddFamilyCommunicationResponseDtoSchema));
};
